module.exports = __webpack_public_path__ + "static/media/failed.b7cc24c6.svg";